module.exports = __webpack_public_path__ + "teacher_en@2x.70dd0eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Teacher/images/teacher_en@2x.png
// module id = hvBK
// module chunks = 0